import config from '~/config';

type TMetaTitle = {
  children: string | string[];
}

const MetaTitle = ({ children }: TMetaTitle) => {
  const title = Array.isArray(children) ? children.join('') : children;
  return <title>{title + ' | ' + config.APP_TITLE}</title>;
}

export default MetaTitle;
